"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _filter = _interopRequireDefault(require("../run/filter"));

var _advanceWidthBetween = _interopRequireDefault(require("../run/advanceWidthBetween"));
/**
 * Advance width between start and end
 * Does not consider ligature splitting for the moment.
 * Check performance impact on supporting this
 *
 * @param  {number}  start offset
 * @param  {number}  end offset
 * @param  {Object}  attributedString
 * @return {number} advance width
 */


var advanceWidthBetween = function advanceWidthBetween(start, end, attributedString) {
  var runs = (0, _filter["default"])(start, end, attributedString.runs);
  return runs.reduce(function (acc, run) {
    return acc + (0, _advanceWidthBetween["default"])(start, end, run);
  }, 0);
};

var _default = advanceWidthBetween;
exports["default"] = _default;